/* eslint-disable import/no-default-export */

import { API } from '@/api'

export default {
  getScorePageInfo({ commit }) {
    return API.memberIntegral.getScoreDetail().then(res => {
      commit('initMemberInfo', res)
      return res
    })
  },
  receiveCoupon({ commit }, data) {
    return API.memberIntegral.memberReceiveCoupon(data).then(res => {
      return res
    })
  },
  // 我的积分页 积分兑换单个商品
  scoreExchangeGoods({ commit }, { ssuId }) {
    return API.memberIntegral
      .scoreExchangeGoods({
        ssuId
      })
      .then(res => {
        return res
      })
  },

  async queryExchangeTrigger() {
    try {
      const result = await API.memberIntegral.queryExchangeTrigger()
      return Promise.resolve(result)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
